import React from "react";
import { useHistory } from "react-router";

import ImagePreventRightClick from "core/ImagePreventRightClick";

import { IconGridItemContainer } from "./styles";

import { ICON_DETAIL_PAGE } from "js/data/links";

const IconGridItem = ({ iconId, iconTerm, iconPreviewUrl, iconSlugWithId }) => {
    const history = useHistory();
    const iconDetailPageUrl = ICON_DETAIL_PAGE.replace(
        ":slugWithId",
        iconSlugWithId
    );

    const redirectToIconDetailPage = () => history.push(iconDetailPageUrl);

    return (
        <IconGridItemContainer
            as="a"
            href={iconDetailPageUrl}
            onClick={e => {
                e.preventDefault();
                redirectToIconDetailPage();
            }}
        >
            <ImagePreventRightClick
                imageSrc={iconPreviewUrl}
                srText={`${iconTerm} Icon ${iconId}`}
            />
        </IconGridItemContainer>
    );
};

export default IconGridItem;
